import Dialog from "../../components/Dialog";
import { ReactComponent as InformationModal } from "../../assets/icons/InformationModal.svg";
import DialogStyles from "../../styles/components/DialogStyles";
import ButtonStyles from "../../styles/components/ButtonStyles";

const { StyledModalTitle, StyledModalText, StyledContainerButton } =
    DialogStyles;
const { BtnPrimary } = ButtonStyles;

interface IModalScheduleBlock {
    blockByAfastamento: boolean;
    isOpen: boolean;
    onHide: () => void;
}

const ModalScheduleBlock: React.FC<IModalScheduleBlock> = ({
    isOpen,
    onHide,
    blockByAfastamento,
}) => {
    return (
        <Dialog
            openModal={isOpen}
            onHide={() => onHide()}
            size="width-300"
            modalIcon={<InformationModal />}
        >
            <StyledModalTitle style={{ fontSize: "22px" }}>
                {blockByAfastamento
                    ? "AGENDA BLOQUEADA"
                    : "AJUSTE DE CARGA HORÁRIA"}
            </StyledModalTitle>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                {blockByAfastamento
                    ? "Agenda bloqueada para edição."
                    : "Houve ajuste de sua carga horária e você precisa atualizar o seu TACH para liberar a sua AGENDA."}
            </StyledModalText>
            <StyledContainerButton>
                <BtnPrimary onClick={() => onHide()}>Ok</BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );
};

export default ModalScheduleBlock;
